import { Fragment } from 'react';
import { Link } from 'react-router-dom';

const LINKS = [
    { label: 'Pricing', to: '/pricing' },
    { label: 'FAQ', to: '/faq' },
    { label: 'Terms of Service', to: '/terms' },
    { label: 'Privacy Policy', to: '/privacy' },
];

/**
 * Shared public footer. `variant` picks the class family that the page's
 * stylesheet already defines: `landing` for LandingPage.css, `legal` for
 * LegalPage.css. The component imports no CSS of its own.
 */
export default function Footer({ variant = 'landing' }) {
    const base = variant === 'legal' ? 'legal-footer' : 'landing-footer';
    return (
        <footer className={base}>
            <div className={`${base}-links`}>
                {LINKS.map(({ label, to }, index) => (
                    <Fragment key={to}>
                        {index > 0 && <span className={`${base}-divider`}>&middot;</span>}
                        <Link to={to}>{label}</Link>
                    </Fragment>
                ))}
                <span className={`${base}-divider`}>&middot;</span>
                <a href="mailto:support@censuszen.com">Contact</a>
            </div>
            &copy; {new Date().getFullYear()} CensusZen. All rights reserved.
        </footer>
    );
}
